module.exports = __webpack_public_path__ + "static/media/10.40831064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/10.jpg
// module id = 379
// module chunks = 0